import {
  ACCOUNTS_FETCH,
  ACCOUNTS_FETCH_ALL,
  ACCOUNTS_IS_FETCING,
  ACCOUNT_FILTER,
	ACCOUNT_EDIT,
  SET_ACCOUNT_PROFILE,
	SET_ACCOUNT_IB,
  SET_ACCOUNT_CLIENT
} from 'constants/accounts'

export default function accountsReducer(state = {
	list: [],
  selectedClientId: '',
  selectedClientName: 'Clients',
  selectedIbId: '',
  selectedIbName: 'IBs',
  selectedProfileId: '',
  selectedProfileName: 'Profiles',
	pageable: {
    sort: {
        'accountId': 'asc',
        'number': 'asc',
    },
    size: 10,
    page: 0,
    totalPages: 0,
    totalElements: 0,
  }
}, action) {
  switch (action.type) {
      case ACCOUNTS_FETCH:
          return {
              ...state,
              list: action.payload,
          }
      case ACCOUNTS_FETCH_ALL:
          return {
              ...state,
              list: action.payload,
          }
      case ACCOUNT_EDIT:
          return {
              ...state,
          }
      case ACCOUNTS_IS_FETCING:
          return {
              ...state,
              isFetching: action.payload,
          }
      case SET_ACCOUNT_PROFILE:
          return {
            ...state,
                        selectedProfileId: action.payload.profileId,
                        selectedProfileName: action.payload.profileName
          }
      case SET_ACCOUNT_IB:
					return {
						...state,
                        selectedIbId: action.payload.ibId,
                        selectedIbName: action.payload.ibName
					}
      case SET_ACCOUNT_CLIENT:
          return {
            ...state,
                        selectedClientId: action.payload.clientId,
                        selectedClientName: action.payload.clientName
          }
      case ACCOUNT_FILTER:
          return {
              ...state,
              pageable: {
                  ...state.pageable,
                  ...action.payload,
                  sort: action.payload.sort ? {
                      ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                          ...obj,
                          [i]: false
                      }), {}),
                      ...action.payload.sort
                  } : state.pageable.sort,
              },
          }
      default:
          return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/accounts.js